<template>
    <div id="promotor_tools_container">
        <div id="share_info">
        <p>Enviar Link</p>
        <a id="share_info_mail" class="share_email share_btn" @click="openInputMail()"></a>
        <a id="share_info_wsp" class="share_wsp share_btn" @click="openInputWsp()"></a>
        <a id="reload_tracking" @click="reloadTracking()"></a>
    </div>
    <v-dialog v-model="dialog" width="600px">                
        <v-card elevation="1">
                <v-card-title style="font-size:16px">Ingresá el mail del cliente</v-card-title>
                <v-text-field variant="outlined" id="email-input-promotor" @wheel="$event.target.blur()" v-model="to_email" style="width:90%; margin:auto"></v-text-field>
                <v-card-actions>
                    <v-btn @click="sendMail()" small color="primary" id="send-email">Aceptar</v-btn>
                    <v-btn @click="dialog=false" small>Cancelar</v-btn>
                </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="wspdialog" width="600px">                
        <v-card elevation="1">
                <v-card-title style="font-size:16px">Ingresá el celular del cliente con código de área sin 0 y sin 15</v-card-title>
                <v-text-field variant="outlined" @wheel="$event.target.blur()" id="whatsapp-input-promotor" v-model="to_whatsapp" style="width:90%; margin:auto"></v-text-field>
                <v-card-actions>
                    <v-btn @click="sendWsp()" small color="primary" id="send-whatsapp">Aceptar</v-btn>
                    <v-btn @click="wspdialog=false" small>Cancelar</v-btn>
                </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- <div id="share_payment" style="display:none;">
        <p>Pago</p>
        <a id="share_payment_email" class="share_email share_btn"></a>
        <a id="share_payment_wsp" class="share_wsp share_btn"></a>
    </div> -->
    <div id="logout_btn" @click="()=>logoutdialog=true">
        <v-dialog v-model="logoutdialog" width="500px">                
        <v-card elevation="1">
                <v-card-title style="font-size:16px">¿Desea cerrar sesión?</v-card-title>
                <v-card-actions>
                    <v-btn @click="logout()" small color="primary">Aceptar</v-btn>
                    <v-btn @click="logoutdialog=false" small>Cancelar</v-btn>
                </v-card-actions>
        </v-card>
    </v-dialog>
    </div>

   
</div>

</template>

<script>
import Input from '@/components/Input.vue';
import { getPathURL, getCookie, reloadCookie } from '@/utils/functions';
import * as Tracking from '@/utils/tracking';

export default {
components:{Input},
data(){
    return {
        to_whatsapp:"",
        to_email:"",
        body:"",
        dialog:false,
        wspdialog:false,
        logoutdialog:false
    }
    }, 
methods: {

    openInputMail(e) {
        this.dialog=true;
    },
    sendMail() 
    {
        Tracking.FourthStepPlus();
        var mailtoLink ='mailto:' + this.to +'?subject=' + encodeURIComponent(this.$cookies.get('promotorName') + ' de URG') + '&body=' + encodeURIComponent('Afiliate a URG ingresando a ' + getPathURL() + this.$router.history.current.fullPath + '?codigoPromotor=' +this.$cookies.get('codPromotor') +'&session=' +getCookie());
        // Abre la ventana de correo electrónico
        window.open(mailtoLink);
        this.dialog = false;
    },
    openInputWsp(e) {
        this.wspdialog=true;
    },
    sendWsp() 
    {
        Tracking.FourthStepPlus();

        const cookie = getCookie();
        var path = this.$router.history.current.fullPath
        if(path.slice(-1) == '/') {
            path = path.slice(0, -1)
        };
        const text = "Afiliate a URG ingresando a " + getPathURL() + path + "/?codigoPromotor=" + encodeURIComponent(this.$cookies.get('codPromotor')) + "&session=" + encodeURIComponent(getCookie());
        const url = "http://api.whatsapp.com/send?phone=549" + this.to_whatsapp + "&text=" + encodeURIComponent(text);
        window.open(url);

        this.wspdialog = false;
    },
    reloadTracking(e) {
        const cookie = reloadCookie();
        location.reload();
       
    },
    logout() {
        this.logoutdialog=false;
        this.$cookies.remove('codPromotor');
        this.$cookies.remove('promotor');
        this.$cookies.remove('promotorName');
        if(this.$router.history.current.path == "/"){
            location.reload()
        } else {
            this.$router.push("/")
        }
    }

}
}
</script>

<style scoped>

#promotor_tools_container {
    display: grid;
    position: fixed;
    z-index: 2;
    bottom: 0;
    width: 100%;
    grid-template-columns: 270px 270px auto;
    grid-template-rows: 1fr;
    border-top: 2px solid #06AAD2;
    background-color: white;
    height: 70px;
}

#promotor_tools_container div {
    display: grid;
    grid-template-columns: 150px 50px 50px 50px;
    grid-template-rows: 1fr;
    position: relative;
    height: auto;
}


#promotor_tools_container div p {
    text-align: center;
    line-height: 24px;
    font-family: 'Nunito', sans-serif;
    font-weight: 700;
    font-size: 14px;
    color: #203694;
}

#promotor_tools_container div button, #promotor_tools_container div a, #logout_btn {
    background-repeat: no-repeat;
    background-position-x: center;
    background-position-y: center;
    background-size: 30px 30px;
    border: none;
    border-radius: 10px;
    width: 45px;
    height: 45px;
    margin: 10px;
    cursor: pointer;
}

.share_email {
    background-image: url('@/assets/email_icon.webp');
    background-color: #cec17c;
    filter: invert(1);
}

.share_wsp {
    background-image: url('@/assets/whatsapp_icon.webp');
    background-color: #ff57d2;
    filter: invert(1);
}

#reload_tracking {
    background-image: url('@/assets/refresh_icon.png');
    background-color: #be3232;
    filter: invert(1);
    cursor: pointer;
    pointer-events: auto;
    z-index: 10
}

.reload_tracking_btn {
    cursor: pointer;
}
#logout_btn {
    display: block!important;
    position: absolute!important;
    right: 15px!important;
    height: 45px!important;
    width: 45px!important;
    background-image: url('@/assets/logout_icon.webp')!important;
    background-color: #3b3b3b;
    filter: invert(1);
}

</style>